
import { useDispatch, useSelector } from 'react-redux';
import NavBar from '../../components/Navigation/NavBar';
import { TourProvider } from '@reactour/tour'

import './RootScreen.css'
import { selectBlockApp, selectLoadingState } from '../../services/global/globalSlice';
import MainLoader from './MainLoader';
import BlockedScreen from '../DemoScreen/BlockedScreen';
import { selectUserData, selectUserOnboarding, updateUserOnboarding } from '../../features/User/userSlice';
import { Close, TourNavigation} from '../DemoScreen/_components/StepComponents';
import TourWrapper from '../DemoScreen/_components/TourWrapper';
import OperationsPanel from '../../features/Operations/OperationsPanel';

import { isMobile } from 'react-device-detect';
import MobileScreen from './MobileScreen';


export default function RootScreen ({children}) {
  
    const isLoading = useSelector(selectLoadingState)
    const blockApp = useSelector(selectBlockApp)
    const dispatch = useDispatch()
    const userOnboarding = useSelector(selectUserOnboarding)
    const userData = useSelector(selectUserData)

    const handleTourClose = (action) => {
        if(!userOnboarding || (userOnboarding[action.meta] && !userOnboarding[action.meta]?.section_completed)){
            dispatch(
                updateUserOnboarding({
                onboarding_step: {
                    step_completed_count: action.currentStep + 1,
                    section_completed: true,
                    section: action.meta
                },
                })
            );
        }
        action.setIsOpen(false)
    };

    return(
        <div id="rootScreen">
            <div id="adminAppContainer">
                <NavBar />
                {isLoading ? <MainLoader /> : ""}
                {
                    isMobile && !userData?.is_super_admin ?
                        <MobileScreen />
                    :
                        <>
                        {blockApp ? 
                            <BlockedScreen /> :
                            <TourProvider 
                                showBadge={false}
                                components={{ // Personalizza i controlli
                                    Close: Close,
                                    Navigation: TourNavigation, // Personalizza i dot di navigazione
                                }}
                                onClickClose={handleTourClose}
                            >
                                <TourWrapper>
                                    {children}
                                    <OperationsPanel />
                                </TourWrapper>
                            </TourProvider>    
                        } 
                        </>
                }
            </div>
        </div>
    )
}
